import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './en.json';
import de from './de.json';

Vue.use(VueI18n);

const messages = {
  en,
  de,
};
const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  formatFallbackMessages: true,
  messages,
});

export default i18n;
